import { render } from "./CustomerPaymentCards.vue?vue&type=template&id=b1aa1b04"
import script from "./CustomerPaymentCards.vue?vue&type=script&lang=js"
export * from "./CustomerPaymentCards.vue?vue&type=script&lang=js"

import "./CustomerPaymentCards.vue?vue&type=style&index=0&id=b1aa1b04&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__